document.addEventListener("DOMContentLoaded", function () {

  const STORAGE_KEY = "wishlist_products";

  function getWishlist() {
    return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
  }

  function saveWishlist(list) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    updateWishlistCount();
  }

  function updateWishlistCount() {
    const count = getWishlist().length;

    document.querySelectorAll(".wishlist-count").forEach(el => {
      if (count > 0) {
        el.textContent = count;
        el.style.display = "inline-flex";
      } else {
        el.style.display = "none";
      }
    });
  }

  function toggleWishlist(handle, el) {
    let list = getWishlist();

    if (list.includes(handle)) {
      list = list.filter(item => item !== handle);
      el.classList.remove("active");
    } else {
      list.push(handle);
      el.classList.add("active");
    }

    saveWishlist(list);
  }

  // ✅ EVENT DELEGATION (IMPORTANT FIX)
  document.addEventListener("click", function (e) {
    const icon = e.target.closest(".product-wishlist");
    if (!icon) return;

    e.preventDefault();

    const handle = icon.dataset.productHandle;
    if (!handle) return;

    toggleWishlist(handle, icon);
  });

  // ✅ ACTIVE STATE for dynamically loaded products
  function syncWishlistUI() {
    const list = getWishlist();
    document.querySelectorAll(".product-wishlist").forEach(icon => {
      const handle = icon.dataset.productHandle;
      if (list.includes(handle)) {
        icon.classList.add("active");
      } else {
        icon.classList.remove("active");
      }
    });
  }

  // Dawn section reload support
  document.addEventListener("shopify:section:load", syncWishlistUI);

  syncWishlistUI();
  updateWishlistCount();
});





//zoom code

document.addEventListener("click", function (e) {

  const zoomBtn = e.target.closest(".zoom-icon");
  const lightbox = document.getElementById("zoom-lightbox");
  const zoomImg = document.getElementById("zoom-lightbox-img");
  const closeBtn = document.querySelector(".zoom-close");

  /* OPEN LIGHTBOX */
  if (zoomBtn) {
    const imgSrc = zoomBtn.dataset.zoomImage;
    if (!imgSrc) return;

    zoomImg.src = imgSrc;
    zoomImg.style.transform = "scale(1)";
    zoomImg.style.transformOrigin = "center center";
    lightbox.style.display = "flex";
  }

  /* CLOSE LIGHTBOX */
  if (e.target === lightbox || e.target === closeBtn) {
    lightbox.style.display = "none";
    zoomImg.src = "";
  }
});

/* ===== HOVER ZOOM EFFECT ===== */
const zoomImg = document.getElementById("zoom-lightbox-img");

zoomImg.addEventListener("mousemove", function (e) {
  const rect = zoomImg.getBoundingClientRect();
  const x = ((e.clientX - rect.left) / rect.width) * 100;
  const y = ((e.clientY - rect.top) / rect.height) * 100;

  zoomImg.style.transformOrigin = `${x}% ${y}%`;
  zoomImg.style.transform = "scale(2)";
});

zoomImg.addEventListener("mouseleave", function () {
  zoomImg.style.transformOrigin = "center center";
  zoomImg.style.transform = "scale(1)";
});
